module.exports = __webpack_public_path__ + "static/media/panthers-silhouette.dafc209d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/panthers-silhouette.svg
// module id = 1330
// module chunks = 0